import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip, Rating } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const TestimonialsTableRow = ({
    item,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(item.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, item.id)}
                />
            </TableCell>

            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic
                    ? (item?.name?.ar || item?.name?.en || (typeof item?.name === 'string' ? item.name : '-'))
                    : (item?.name?.en || item?.name?.ar || (typeof item?.name === 'string' ? item.name : '-'))
                }
            </TableCell>

            <TableCell align="center">
                <Rating value={Number(item?.rating) || 0} readOnly size="small" />
            </TableCell>

            <TableCell align="center">
                <Chip
                    label={item?.show_in_home ? (isArabic ? 'نشط' : 'Active') : (isArabic ? 'غير نشط' : 'Inactive')}
                    size="small"
                    color={item?.show_in_home ? 'success' : 'default'}
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            <TableCell align="center">
                {item?.sort_order ?? '-'}
            </TableCell>

            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {item?.created_at ? dayjs(item.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, item)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default TestimonialsTableRow;
